/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_ADDRESS,
  SET_PAYMENT_TYPE_OPTIONS,
  FNOL_GET_PAYMENT_CODE_TYPES,
  FNOL_GET_PAYMENT_FORM_FIELDS,
  FNOL_GET_PAYMENT_CODE_TYPES_SUCCESS,
  FNOL_GET_PAYMENT_FORM_FIELDS_SUCCESS,
  FNOL_SET_DYNAMIC_FIELD_VALUE,
  FNOL_RESET_DYNAMIC_FORM,
  FNOL_SET_SELECTED_CODE_TYPE,
  FNOL_VALIDATE_CODE_FIELD,
  FNOL_SET_CODE_VERIFICATION_FAILED,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function nextSlide(errors) {
  return {
    type: NEXT,
    errors,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function resetFormDataAddress() {
  return {
    type: RESET_ADDRESS,
  };
}

export function setPaymentTypeOptions(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function fnolGetPaymentCodeTypes(countryId) {
  return { type: FNOL_GET_PAYMENT_CODE_TYPES, countryId };
}

export function fnolGetPaymentFormFields(countryId, codeTypeId) {
  return { type: FNOL_GET_PAYMENT_FORM_FIELDS, countryId, codeTypeId };
}

export function fnolSetPaymentCodeTypes(data) {
  return { type: FNOL_GET_PAYMENT_CODE_TYPES_SUCCESS, data };
}

export function fnolSetPaymentFormFields(data) {
  return { type: FNOL_GET_PAYMENT_FORM_FIELDS_SUCCESS, data };
}

export function fnolSetDynamicFieldValue(fieldName, value) {
  return { type: FNOL_SET_DYNAMIC_FIELD_VALUE, fieldName, value };
}

export function fnolResetDynamicForm() {
  return { type: FNOL_RESET_DYNAMIC_FORM };
}

export function fnolSetSelectedCodeType(codeTypeId) {
  return { type: FNOL_SET_SELECTED_CODE_TYPE, codeTypeId };
}

export function fnolValidateCodeField(countryId, codeTypeId, code) {
  return { type: FNOL_VALIDATE_CODE_FIELD, countryId, codeTypeId, code };
}

export function fnolSetCodeVerificationFailed() {
  return { type: FNOL_SET_CODE_VERIFICATION_FAILED };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepPaymentDetails/actions.js